import Axios, {AxiosResponse} from "axios"
import * as _ from "lodash"
import Vue from "vue"

export async function restDownloadFile(
  path: string,
  filename: string,
  parameters?: Record<string, string | null>
): Promise<AxiosResponse> {
  return Axios.get(path, {
    params: parameters,
    responseType: "blob",
  }).then((response: AxiosResponse) => {
    handleResponse(response, filename)
    return response
  })
}

export async function restPostDownloadFile(
  path: string,
  filename: string,
  data?: Record<string, unknown> | any
): Promise<void> {
  const reponse: AxiosResponse = await Axios.post(path, data, {
    responseType: "blob",
  })
  handleResponse(reponse, filename)
}

function handleResponse(response: AxiosResponse, filename: string) {
  downloadFile(new Blob([response.data]), filename)
}

export function downloadFile(blob: Blob, filename: string): void {
  const link = document.createElement("a")
  link.href = window.URL.createObjectURL(blob)
  link.setAttribute("download", filename)
  document.body.append(link)
  link.click()
  link.remove()
}

export function getXsrfHeader(): Array<{name: string; value: string}> {
  const xsrfToken = <string | null>Vue.$cookies.get("XSRF-TOKEN")
  return _.isEmpty(xsrfToken) ? [] : [{name: "X-XSRF-TOKEN", value: xsrfToken!}]
}
